import React, { useEffect } from "react";
import logo from "../../assets/img/Logo/logo.svg";
import residencesIcon from "../../assets/img/admin/house.svg";
import graph from "../../assets/img/admin/graph.svg";
import feedbacks from "../../assets/img/admin/messages-2.svg";
import judge from "../../assets/img/admin/judge.svg";
import categories from "../../assets/img/admin/category-2.svg";
import panelads from "../../assets/img/admin/screenmirroring.svg";
import notification from "../../assets/img/admin/notification-bing.svg";
import flash from "../../assets/img/admin/flash.svg";
import adminicon from "../../assets/img/admin/speedometer.svg";
import users from "../../assets/img/admin/profile-2user.svg";

import { Link, useNavigate } from "react-router-dom";
import profile from "../../assets/img/Home/profile.png";
import logout from "../../assets/img/icons/sidebarmenu/login.svg";
import {useUserInfo} from "../../context/UserContext"
import useFetch from "../../hooks/useAxios";
import { useAuth } from "../../context/authContext";
import toast from "react-hot-toast";
const AdminSidebar = () => {
  const SideBarList = [
    {
      url: "/admin/residences",
      title: " لــیست اقـامـتگـاه هــا",
      img: residencesIcon
    },
    {
      url: "/admin/statistic",
      title: "آمـــار  وبــسـایـت",
      img: graph
    },
    {
      url: "/admin/wage",
      title: "کارمزد  ",
      img: graph
    },
    {
      url: "/admin/feedback",
      title: "فــیدبک هـای وبـسایت",
      img: feedbacks
    },
    {
      url: "/admin/judje",
      title: "اخـتــلاف و شــکایــات",
      img: judge
    },
  
    {
      url: "/admin/categories",
      title: "دســتــه بــنـدی هـــا",
      img: categories
    },
    {
      url: "/admin/ads-panel",
      title: "پنل تــــبلـــیغـاتی ",
      img: panelads
    },
    {
      url: "/admin/notification",
      title: "اعــلانــات وبــسایــت",
      img: notification
    },
    {
      url: "/admin/fast-search",
      title: "جــست و جــوی سریــع",
      img: flash
    }
    , {
      url: "/admin/add-faq",
      title: " سوالات متداول",
      img: flash
    }
  ];
 
  
  const { authDispatch, authRefreshDispatch } = useAuth();

  const {userinfo}=useUserInfo()
 const navigate = useNavigate()
 const logoutFetch = useFetch({
  method: "post",
  url: "api/logout",
  noHeader: false,
  trigger: false,
 
  argFunc: res => {
    authDispatch({
      type: "LOGOUT"
     
    });
    toast.success("شما با موفقیت از حساب کاربری خود خارج شدید.")
    navigate("/")
  }
});


   return (
    <div className="UserPanelSidebar AdminSidebar">
      <div>
        <Link to="/">
          <img src={logo} />
        </Link>
      </div>
      <div>
      <div className="userProfile ">
        <div className="relative" >
          <img src={userinfo.data.user.avatar}className="profile-img " />
         
        </div>
        <h6 className="my-[10px]">{userinfo.data.user.full_name}</h6>
        <p>{userinfo.data.user.phone}</p>
      </div>
      <hr className="mb-[25px]"/>
      <ul>
      {/* <Link to={`/admin`}>
            <li className="flex gap-[15px] items-center">
              <img src={adminicon} /> <span>داشبورد ادمین</span>{" "}
            </li>
          </Link> */}
          <div className="primary-box">
          <Link to={`/admin/users`}>
            <li className="flex gap-[15px] items-center">
              <img src={users} /> <span>کاربــران جـــاتـیک</span>{" "}
            </li>
          </Link>

          </div>

        {SideBarList.map(i =>
          <Link to={`${i.url}`}>
            <li className="flex gap-[15px] items-center">
              <img src={i.img} /> <span>{i.title}</span>{" "}
            </li>
          </Link>
        )}
      </ul>
      </div>
      <div className="UserPanelSidebar__logout flex gap-[15px] items-center cursor-pointer" onClick={()=>logoutFetch.reFetch()}>
        <img src={logout} />

        <p>خروج از حساب کاربری</p>
      </div>
    </div>
  );
};


export default AdminSidebar